export const TypesOfsale = [
    { value: 'Bienes', label: 'Bienes' },
    { value: 'Servicios', label: 'Servicios' },
    { value: 'Ambos', label: 'Ambos' },
    { value: 'Otros', label: 'Otros' },

]